import React, { useCallback, useMemo, useRef, useState } from 'react';
import Webmenu from "../../layouts/webmenu";
import Topbar from "../../layouts/topbar";
import { ThreeDots } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { styleSelect } from "../../constants/customStyles";
import { useNavigate, useParams } from "react-router-dom";
import Select from 'react-select';
import { useEffect } from "react";
import { getAllState } from "../../actions/StateAction";
import { getAllVehicleCode } from "../../actions/VehicleCodeActions";
import DataTable from "react-data-table-component";
import { createRoot } from 'react-dom/client';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Toast from '../../components/Toast';
import { saveParallelJob, getParallelJobById } from '../../actions/ParallelJobActions';
import { getBatchById } from '../../actions/BatchActions';
import moment from 'moment/moment';
import Mobilemenu from '../../layouts/mobile-menu';

function ParallelJobs() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();

    useEffect(() => {
        dispatch(getParallelJobById(params.id))
        dispatch(getBatchById(params.id))
    }, [])

    const loading = useSelector(state => state?.loading?.loading);
    const parallelJob = useSelector(state => state?.parallelJob?.parallelJob);
    const batch = useSelector(state => state?.batch?.batch);

    const [totalAmountOfBatch, setTotalAmountOfBatch] = useState('');

    const gridStyle = useMemo(() => ({ height: '400px', overflowY: 'auto', width: '100%' }), []);
    const [batchId, setBatchId] = useState('');
    const [noOfInvoice, setNoOfInvoice] = useState('');
    const [rowData, setRowData] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [columnDefs, setColumnDefs] = useState([
        { field: 'invoice_no', headerName: 'Invoice No.', editable: false },
        { field: 'customer_name', headerName: 'Customer Name' },
        { field: 'customer_mobile', headerName: 'Customer Mobile' },
        { field: 'vehicle_plate_number', headerName: 'Vehicle Plate Number' },
        { field: 'total_amount', headerName: 'Total Amount' },
    ]);

    useEffect(() => {
        if (parallelJob && Object.keys(parallelJob).length > 0) {
            setNoOfInvoice(parallelJob?.no_of_invoices);
            setInvoices(
                parallelJob?.parallel_job_detail.map((detail, index) => ({
                    invoice_no: index + 1,
                    customer_name: detail?.customer?.name,
                    customer_mobile: detail?.customer?.mobile,
                    vehicle_plate_number: detail?.vehicle?.plate_number,
                    total_amount: detail?.job_card_details[0]?.total_amount
                }))
            );
        }
    }, [parallelJob])

    useEffect(() => {
        setTotalAmountOfBatch(batch.total_amount_count);
        setBatchId(params.id);
    }, [batch])

    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            minWidth: 100,
            menuTabs: false,
            editable: parallelJob?.parallel_job_detail ? false : true,
        };
    }, [parallelJob?.parallel_job_detail]);
    const [count, setCount] = useState(0);
    const handleInputChange = (event) => {
        setNoOfInvoice(event.target.value);
        const inputValue = parseInt(event.target.value, 10);
        setCount(inputValue);

        if (!isNaN(inputValue)) {
            const newRows = Array.from({ length: inputValue }, (_, index) => ({
                'invoice_no': index + 1,
                'customer_name': invoices.customer_name ? invoices.customer_name : '',
                'customer_mobile': invoices.customer_mobile ? invoices.customer_mobile : '',
                'vehicle_plate_number': invoices.vehicle_plate_number ? invoices.vehicle_plate_number : '',
                'total_amount': invoices.total_amount ? invoices.total_amount : 0,
            }));
            setRowData(newRows);
        } else {
            setRowData([]);
        }
    };
    const calculateTotalAmount = () => {
        let totalAmount = 0;
        for (const invoice of invoices) {
            totalAmount += parseFloat(invoice.total_amount);
        }
        return totalAmount;
    };

    const handleChange = (e) => {
        // console.log(rowData)
        const updatedInvoice = { ...e.data };
        const existingIndex = invoices.findIndex(invoice => invoice.invoice_no === updatedInvoice.invoice_no);

        const oldTotalAmount = existingIndex !== -1 ? invoices[existingIndex].total_amount : 0;
        const newTotalAmount = parseFloat(updatedInvoice.total_amount); // Make sure it's a number

        if (newTotalAmount < 0) {
            Toast.fire({
                icon: 'warning',
                title: 'Amount Cannot be Negative!'
            });
            return;
        }
        if (e.colDef.field === 'customer_name' && /\d/.test(e.data.customer_name)) {
            updatedInvoice.customer_name = '';
            Toast.fire({
                icon: 'warning',
                title: 'Name shouldnot be a Number!'
            });
            return;
        }

        if (e.colDef.field === 'customer_mobile' && /[A-Za-z]/.test(e.data.customer_mobile)) {
            updatedInvoice.customer_mobile = '';
            Toast.fire({
                icon: 'warning',
                title: 'Mobile Number shouldnot contain Alphabets!'
            });
            return;
        }

        const diffTotalAmount = newTotalAmount - oldTotalAmount;

        const newTotalAmountOfBatch = totalAmountOfBatch - diffTotalAmount;

        if (newTotalAmountOfBatch < 0) {
            Toast.fire({
                icon: 'warning',
                title: 'Total Amount Limit Exceeds!'
            });
            return;
        }

        const updatedInvoices = existingIndex !== -1
            ? invoices.map(invoice =>
                invoice.invoice_no === updatedInvoice.invoice_no
                    ? { ...invoice, ...updatedInvoice, total_amount: newTotalAmount }
                    : invoice
            )
            : [...invoices, { ...updatedInvoice, total_amount: newTotalAmount }];

        setInvoices(updatedInvoices);
        setTotalAmountOfBatch(newTotalAmountOfBatch);
    };
    console.log(invoices);

    const validateAllCellsFilled = () => {
        return invoices.some(invoice =>
            invoice.customer_name === '' ||
            invoice.total_amount === '' ||
            invoice.customer_mobile === '' ||
            invoice.vehicle_plate_number === ''
        );
    };

    const save = () => {
        if (noOfInvoice.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'No of Invoices is Required!'
            })
        } else if (invoices.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Please Fill Invoices!'
            })
        } else if (rowData.length !== invoices.length) {
            Toast.fire({
                icon: 'error',
                title: 'Please Fill All Invoices!'
            })
        } else if (validateAllCellsFilled()) {
            Toast.fire({
                icon: 'error',
                title: 'Please Fill All Fields!'
            })
        } else if (parseFloat(calculateTotalAmount()).toFixed(2) !== parseFloat(batch?.total_amount_count).toFixed(2)) {
            Toast.fire({
                icon: 'error',
                title: 'Amounts didnot Match!'
            })
        } else {
            let data = {
                no_of_invoice: noOfInvoice,
                batch_id: batchId,
                invoices: invoices,
            }
            dispatch(saveParallelJob(data, navigate));
        }
        // window.location.href = ('/state');
    }

    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    {
                        loading ?
                            <ThreeDots
                                height="80"
                                width="80"
                                radius="9"
                                color="#2d3748"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                wrapperClassName=""
                                visible={loading}
                            /> :
                            <span>
                                <div className="grid columns-12">
                                    <div className="g-col-12 g-col-md-7">
                                        <div class="box p-2 mt-5">
                                            <h2 className="fs-base fw-medium p-2 pb-0">
                                                Batch Info :
                                            </h2>
                                            <div className="grid columns-12">
                                                <div className="g-col-md-6">
                                                    <div class="ticket-item d-flex align-items-center p-2 bg-white rounded-2">
                                                        <div class="ticket-item__item-name truncate me-1">Batch No. : </div>
                                                        <div class="ms-auto fw-medium">{batch?.batch_id}</div>
                                                    </div>
                                                    <div class="ticket-item d-flex align-items-center p-2 bg-white rounded-2">
                                                        <div class="ticket-item__item-name truncate me-1">Insurance Company : </div>
                                                        <div class="ms-auto fw-medium">{batch?.insurance_company?.name}</div>
                                                    </div>
                                                </div>
                                                <div className="g-col-md-6">
                                                    <div class="ticket-item d-flex align-items-center p-2 bg-white rounded-2">
                                                        <div class="ticket-item__item-name truncate me-1">No. Of Jobs : </div>
                                                        <div class="ms-auto fw-medium">{batch?.batch_detail_count} Jobs</div>
                                                    </div>
                                                    <div class="ticket-item d-flex align-items-center p-2 bg-white rounded-2">
                                                        <div class="ticket-item__item-name truncate me-1">Created On : </div>
                                                        <div class="ms-auto fw-medium">{moment(batch?.created_at).format('DD-MM-YYYY')}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="g-col-12 g-col-md-5">
                                        {
                                            parallelJob?.no_of_invoices ?
                                                <div className="intro-y box p-5 mt-5">
                                                    <label for="crud-form-1" className="form-label"> No. Of Invoices <span className="text-theme-6">*</span> :</label>
                                                    <input disabled id="crud-form-1" type="text" value={noOfInvoice}
                                                        onChange={handleInputChange} className="form-control w-full" placeholder="Enter No. Of Invoices" />
                                                </div>
                                                :
                                                <div className="intro-y box p-5 mt-5">
                                                    <label for="crud-form-1" className="form-label"> No. Of Invoices <span className="text-theme-6">*</span> :</label>
                                                    <input id="crud-form-1" type="text"
                                                        onChange={handleInputChange} className="form-control w-full" placeholder="Enter No. Of Invoices" />
                                                </div>
                                        }
                                    </div>
                                </div>
                                <div className="intro-y d-flex align-items-center mt-5">
                                    <h2 className="fs-lg fw-medium me-auto ms-3">
                                        Parallel Jobs
                                    </h2>
                                </div>
                                <div className="intro-y box p-5 mt-5">
                                    <div className="grid columns-12">
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label"> Total Amount of Batch <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="text"
                                                disabled value={parseFloat(batch?.total_amount_count).toFixed(2) + ' AED'} className="form-control w-full" />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label"> Current Total Amount <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="text"
                                                disabled value={calculateTotalAmount() + ' AED'} className="form-control w-full" />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label"> Remaining Amount <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="text"
                                                disabled value={parseFloat(batch?.total_amount_count - calculateTotalAmount()).toFixed(2) + ' AED'} className="form-control w-full" />
                                        </div>
                                    </div>
                                </div>
                                {
                                    parallelJob?.parallel_job_detail ?
                                        <div style={gridStyle} className="ag-theme-alpine box mt-5">
                                            <AgGridReact
                                                onCellValueChanged={(e) => handleChange(e)}
                                                rowData={invoices}
                                                columnDefs={columnDefs}
                                                defaultColDef={defaultColDef}
                                                singleClickEdit={true}
                                            />
                                        </div>
                                        :
                                        <div style={gridStyle} className="ag-theme-alpine box mt-5">
                                            <AgGridReact
                                                onCellValueChanged={(e) => handleChange(e)}
                                                rowData={rowData}
                                                columnDefs={columnDefs}
                                                defaultColDef={defaultColDef}
                                                singleClickEdit={true}
                                            />
                                        </div>
                                }
                                <div className="text-end mt-5">
                                    <button type="button" onClick={() => navigate('/batch')} className="btn btn-secondary w-24 me-1">Back</button>
                                    {
                                        !parallelJob?.parallel_job_detail &&
                                        <button type="button" onClick={save} disabled={loading} className="btn btn-primary w-24">{loading ? 'Loading' : 'Save'}</button>
                                    }
                                </div>
                            </span>
                    }
                </div>
            </div>
        </React.Fragment >
    )
}
export default ParallelJobs;